import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ContactCardList"] */ "/app/src/components/new/ContactCardList/ContactCardList.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CorporateCSRForm"] */ "/app/src/components/new/CSR/CorporateCSRForm.tsx");
